import i18n from "i18next";
import { type FC, useCallback } from "react";

import { PrimaryButton } from "../Buttons/components/ActionButton";

export type OkButtonProps = {
    isDisabled: boolean;
    onClick: () => void;
    onBeforeNavigate?: () => void;
};

export const OkButton: FC<OkButtonProps> = ({ isDisabled, onClick, onBeforeNavigate }) => {
    const callback = useCallback(() => {
        if (onBeforeNavigate) onBeforeNavigate();
        onClick();
    }, [onBeforeNavigate, onClick]);

    return (
        <PrimaryButton name="ok_form" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.ok")}
        </PrimaryButton>
    );
};
